module.exports = __webpack_public_path__ + "img/error-icon.07c94224.png";